import FileSaver from 'file-saver'
import XLSX from 'xlsx'

/**
 * 导出excel
 * @param data  数据集合
 * @param fileName  文件名称
 * @param sheetName  sheet名称
 * @returns 0：无待导出数据，1：导出失败，2：导出成功
 */
export function exportExcel(data, fileName, sheetName) {
  if (data === null || data === undefined || data === '' || data.length == 0) {
    return 0
  }
  try {
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.json_to_sheet(data, { header: '' })
    wb.SheetNames.push(sheetName)
    wb.Sheets[sheetName] = ws
    // 表格的样式
    const defaultCellStyle = { font: { name: 'Verdana', sz: 13, color: 'FF00FF88' }, fill: { fgColor: { rgb: 'FFFFAA00' }}}
    // 写入的样式
    const wopts = { bookType: 'xlsx', bookSST: false, type: 'binary', cellStyles: true, defaultCellStyle: defaultCellStyle, showGridLines: false }
    const wbout = XLSX.write(wb, wopts)
    let buf = null
    if (typeof ArrayBuffer !== 'undefined') {
      buf = new ArrayBuffer(wbout.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i != wbout.length; ++i) {
        view[i] = wbout.charCodeAt(i) & 0xff
      }
    } else {
      buf = new Array(wbout.length)
      for (var i = 0; i != wbout.length; ++i) {
        buf[i] = wbout.charCodeAt(i) & 0xFF
      }
    }
    const blob = new Blob([buf], { type: 'application/octet-stream' })
    FileSaver.saveAs(blob, fileName + '.xlsx')
  } catch (e) {
    return 1
  }
  return 2
}
export function fromatExcelTable(val) {
  if (val !== null && val !== undefined && val !== '') {
    return val
  }
  return '--'
}